// extracted by mini-css-extract-plugin
export default {"container":"EZ-z","title":"FZ-z","link":"GZ-z"};